<template>
  <div class="row h-128">

    <article class="col-auto h-100 ms-auto">
      <div class="card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <div class="row mb-3">
            <div class="col">
              <div class="card-text fw-bold">Commande gratuite</div>
            </div>
          </div>

        </div>
      </div>
    </article>

    <action-button :icon="'bi-bag-check'" :text="'Valider\n la commande'" :color="'white'" :type="'success'" @click="placeOrder" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionButton from '@/components/common/ActionButton';

export default {
  props: {
    paymentMethod: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      paid: null,
    };
  },
  components: {
    ActionButton,
  },
  computed: {
    ...mapGetters('cart', ['cart']),
  },
  methods: {
    placeOrder() {
      this.$emit('place-order', { paymentMethod: { method: this.paymentMethod }});
    },
    focusInput() {
      this.$nextTick(() => {
        this.$refs.paid.focus();
      });
    }
  }
};
</script>
